import styled, { css } from 'styled-components';
import {
    colorWhite,
    mediaMd,
    mediaSm,
    mediaXs,
} from 'theme/theme-helper-selectors';

export const Container = styled.div`
    position: relative;
    color: ${colorWhite};
`;

export const TitleWrapper = styled.div`
    margin: 0 0 20px 0;

    @media (${mediaMd}) {
        margin: 0 0 12px 0;
    }
`;

export const SubtitleWrapper = styled.div`
    margin: 0 0 50px 0;
    position: relative;

    @media (${mediaMd}) {
        margin: 0 0 32px 0;
    }

    @media (${mediaSm}) {
        display: none;
    }
`;

export const Subtitle = styled.p`
    font-size: 24px;
    line-height: 27px;
    font-weight: 300;
    opacity: 0.7;
    max-width: 420px;

    @media (${mediaMd}) {
        max-width: initial;
    }
`;

export const ReviewText = styled.div`
    padding: 30px;
    height: 250px;
    position: relative;
    overflow: hidden;
    z-index: 10;

    @media (${mediaSm}) {
        padding: 16px 24px;
        height: 175px;
    }

    &:before {
        transition: all 0.3s ease;
    }
`;

const getPosition = (index: number) => {
    switch (index) {
        case 0:
            return '82% -25px';
        case 1:
            return '62% 40%';
        case 2:
            return '0%';
        case 3:
            return '50% 20%';
        case 4:
            return '100% 0';
        case 5:
            return '55%';
    }
};

export const ReviewImage = styled.div<{ image: string; isFull: boolean }>`
    background-image: url(${({ image }) => image});
    background-repeat: no-repeat;
    height: 250px;

    background-size: ${({ isFull }) => (isFull ? '100%' : '150%')};
`;

export const CarouselArrows = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    gap: 15px;

    @media (${mediaMd}) {
        display: none;
    }
`;

export const Arrow = styled.div`
    width: 50px;
    height: 50px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;

    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        cursor: pointer;
    }
`;

export const TitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    margin: 0 0 16px 0;

    @media (${mediaXs}) {
        margin: 0 0 8px 0;
    }
`;

export const ArrowContainer = styled.div`
    display: none;

    @media (${mediaSm}) {
        width: 20px;
        height: 20px;
    }
`;

export const Review = styled.a<{ index: number }>`
    display: inline-block;
    background: #21272f;
    border-radius: 16px;
    overflow: hidden;
    position: relative;

    ${({ index }) => css`
        ${ReviewImage} {
            background-position: ${getPosition(index)};
        }
    `};

    &:hover {
        color: ${colorWhite};

        ${ArrowContainer} {
            display: block;
        }

        ${ReviewText} {
            &:before {
                display: block;
                content: '';
                z-index: -1;
                width: 100%;
                height: 130%;
                filter: blur(140px);
                left: -60%;
                top: -21%;
                position: absolute;
                background: linear-gradient(
                    242.68deg,
                    rgba(110.85, 89.04, 234.45, 1),
                    rgba(82, 175, 254, 1)
                );
            }
        }
    }
`;

export const ReviewTitle = styled.h4`
    font-size: 32px;
    line-height: 36px;
    font-weight: 400;
    color: ${colorWhite};
    display: inline-block;

    @media (${mediaSm}) {
        font-size: 24px;
        line-height: 27px;
    }
`;

export const ReviewDescription = styled.p`
    font-size: 16px;
    line-height: 18px;
    font-weight: 200;
    color: ${colorWhite};
    opacity: 0.4;

    @media (${mediaSm}) {
        font-size: 14px;
        line-height: 16px;
    }
`;

export const SliderStyler = styled.div`
    .slick-list {
        margin: 0 -10px;

        & .slick-slide > div {
            padding: 0 10px;
        }
    }
`;
